
import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
@Component({
  name: "protocolList",
})
export default class protocolList extends Vue {
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private totalNum = 0;
  private form = {};
  
  data() {
        return {
          options1: [{
            value1: '选项1',
            label1: '上架中'
          }, {
            value1: '选项2',
            label1: '下架中'
          }],
          value1: '',
        }
    }

  private mounted() {
    
    this.getList(1);
  }

  private getList(num:number) {

    let datas = [];
	this.pageNo = num;
    let paramter = {
		'pageNum':this.pageNo,
	  	'pageSize':this.pageSize
    };
    this.$http.get("agreements/list", {params:paramter}).then((res: any) => {
	  	datas = res.data.data.data;
		this.pageNo = num;
		this.pageSize = res.data.data.pageSize;
	  	this.tableData = datas;
		console.log('--',this.tableData);
    });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
    this.getList(this.pageNo);
  }

  private onSubmit() {
    console.log(this.form);
  }
  private addSubmit() {
	  
	  // 新增协议
	   this.$router.push('/Protocol/addprotocol')
  }
  private showDetailDialog(id: number){
	  
	  console.log(id);
	  this.$router.push('/Protocol/protocolDetail/?id='+id);
  }
}
